export const SUPERADMIN_ROLE = 'superadmin';
export const ADMIN_ROLE = 'admin';
export const PRODUCER_ROLE = 'producer';
export const CONSUMER_ROLE = 'consumer';
export const GENERIC_ACCESS_USER_ROLE = 'generic_access_user';
export const WHITE_LABEL_USER_ROLE = 'white_label_user';
